import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLogout } from '../hooks/useLogout';
import { useTheme } from '../ThemeContext';
import './appTopbar.css';
import logoLight from '../images/QuiblyLight.png';
import logoDark from '../images/QuiblyDark.png';
import { FiSettings } from 'react-icons/fi';

function AppTopbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const { darkMode } = useTheme();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className={`appTopbar ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="topbarLeft">
        <img
          src={darkMode ? logoDark : logoLight}
          alt="Quibly Logo"
          className="topbarLogo"
          onClick={() => navigate('/app/resume')}
        />
      </div>

      <div className="topbarCenter">
        <button
          className={`topbarNavBtn ${isActive('/app/resume') ? 'active' : ''}`}
          onClick={() => navigate('/app/resume')}
        >
          Resume Builder
        </button>
        <button
          className={`topbarNavBtn ${isActive('/app/resumes') ? 'active' : ''}`}
          onClick={() => navigate('/app/resumes')}
        >
          My Resumes
        </button>
        <button
          className={`topbarNavBtn ${isActive('/app/profile') ? 'active' : ''}`}
          onClick={() => navigate('/app/profile')}
        >
          Profile
        </button>
      </div>

      <div className="topbarRight">
        <FiSettings
          className="topbarSettingsIcon"
          onClick={() => navigate('/app/settings')}
        />
      </div>
    </div>
  );
}

export default AppTopbar;